import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(process.env.VUE_APP_AUTH_TOKEN);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/*
axios.interceptors.response.use(
  function (response) {
    console.log('API Response:', response); // logs full response
    return response; // important to return the response!
  },
  function (error) {
    console.error('API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);*/

export default axios;
